import { Box, Paper, Radio, Typography, IconButton, Tooltip } from "@mui/material";
import FindInPageOutlined from "@mui/icons-material/FindInPageOutlined";
import makeStyles from '@mui/styles/makeStyles';
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store";
import { ModuloListagem } from "src/components/projetos/types";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import theme from "src/theme/light";

export interface ModuleItem {
  componente_id: number;
  nome: string;
  descricao?: string;
  faturamento?: string | Date;
  selecionado: boolean;
  quantidade: number;
  inversoresTipos?: string[];
}

export interface ModulesListMobileProps {
  modulosList: ModuloListagem[];
  handleSelect: (id: number) => void;
  handleChangeModuleQuantity: (id: number, value: string) => void;
  handleOpenModalDadosTecnicos?: ({ detalhesComponenteId }: { detalhesComponenteId?: number }) => void;
  stringAvatarImg: string;
  microinversorAvatarImg: string;
  titulo: string;
  helperText?: string;
}

const useStyles = makeStyles({
  container: {
    width: '100%'
  },

  title: {
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 20,
    textAlign: "left",
  },

  card: {
    padding: 15,
    borderRadius: 12,
    marginBottom: 25,
  },

  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    position: "relative",
    left: "-9px"
  },

  radio: {
    marginRight: 8,
    marginTop: 4,
  },

  moduloInfo: {
    flex: 1,
    textAlign: "left",
  },

  infoTexto: {
    marginBlock: 3
  },

  attention: {
    color: "#c47a00",
    fontWeight: 600,
  },

  inputQuantidade: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    position: "relative",
    left: "-25px"
  },

  detailsButton: {
    textAlign: "right",
    position: "relative",
    top: 3,
  },

  rowBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 15
  },

  quantityHelperText: {
    color:  theme.palette.error.main,
    display: 'block',
    textAlign: 'left',
    marginLeft: 5,
  },
});

export default function ModulosListMobile({
  modulosList,
  handleSelect,
  handleChangeModuleQuantity,
  handleOpenModalDadosTecnicos,
  stringAvatarImg,
  microinversorAvatarImg,
  titulo,
  helperText,
}: ModulesListMobileProps) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography className={classes.title}>
        {titulo}
      </Typography>
      {modulosList?.map((row) => (
        <Paper key={row.componente_id} className={classes.card} elevation={1}>
          <Box className={classes.cardHeader}>
            <Radio
              checked={row.selecionado}
              onClick={() => handleSelect(row.componente_id)}
              value={row.componente_id}
              className={classes.radio}
            />

            <Box className={classes.moduloInfo}>
              <Typography variant="body1" style={{ fontWeight: 600 }} className={classes.infoTexto}>
                {row.nome}
              </Typography>

              {row.descricao && (
                <Typography variant='body2' color='textSecondary' className={classes.infoTexto}>
                <span className={classes.attention}>Atenção</span>: {row.descricao}
                </Typography>
              )}
              {row.faturamento && (
                <Typography variant='body2' color='textSecondary' className={classes.infoTexto}>
                  Previsão de faturamento: {Formater.toString(row.faturamento, TypeRecords.DATE)}
                </Typography>
              )}
            </Box>
          </Box>

          <Box className={classes.rowBox}>
            <Typography style={{ fontWeight: 500, marginBottom: 4, marginLeft: 4 }}>
              Inversores disponíveis
            </Typography>

            <Box>
              {row.inversoresTipos?.includes("string") && (
                <Tooltip title="String">
                  <img src={stringAvatarImg} alt="String" width={45} />
                </Tooltip>
              )}

              {row.inversoresTipos?.includes("microinversor") && (
                <Tooltip title="Microinversor">
                  <img src={microinversorAvatarImg} alt="Micro" width={45} />
                </Tooltip>
              )}
            </Box>
          </Box>

          <Box className={classes.rowBox}>
            <Box className={classes.inputQuantidade}>
              <InputQuantidade
                disabled={!row.selecionado}
                disabledInput={!row.selecionado}
                value={row.selecionado ? row.quantidade : 0}
                onChange={(value: string) =>
                  handleChangeModuleQuantity(row.componente_id, value)
                }
              />
            </Box>

            <Box className={classes.detailsButton}>
              <IconButton
                onClick={() => {
                  if (handleOpenModalDadosTecnicos) {
                    handleOpenModalDadosTecnicos({ detalhesComponenteId: row.componente_id })
                  } else {
                    modalComponentesDetalhesData$.next(row.componente_id)
                  }
                }}
                size="large">
                <FindInPageOutlined htmlColor="black" fontSize="large" />
              </IconButton>
            </Box>
          </Box>

          {helperText && <small className={classes.quantityHelperText}>{helperText}</small>}
        </Paper>
      ))}
    </Box>
  );
}